namespace TabAurous.Common {
    export enum ToneType {
        SingleTone = 1,
        DualTone = 2,
        TripleTone = 3
    }
    Serenity.Decorators.registerEnumType(ToneType, 'TabAurous.Common.ToneType', 'Administration.ToneTpe');
}
